import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import EventBus from '../components/event-bus';

let ongoingRequests = [];
const exceptUrl = `${process.env.VUE_APP_ENDPOINT_URL}/api/reports`;
const exceptErrorUrls = [
  `${process.env.VUE_APP_ENDPOINT_URL}/api/reports/error`,
  `${process.env.VUE_APP_ENDPOINT_URL}/reports/error`,
  `${process.env.VUE_APP_ENDPOINT_URL}/login`,
];

// workaround for cyclic imports
// eslint-disable-next-line import/no-cycle
const storePromise = import('@/store');

function triggerEventBus(routeId) {
  setTimeout(() => {
    const checkRoute = ongoingRequests.find((ongoingRequest) => ongoingRequest.id === routeId);
    const routeIndex = ongoingRequests.findIndex((ongoingRequest) => ongoingRequest.id === routeId);
    if (checkRoute && +checkRoute.count === 0) {
      ongoingRequests.splice(routeIndex, 1);
      EventBus.$emit('pageLoaded', true);
    }
  }, 1500);
}

// Add a request interceptor
axios.interceptors.request.use(async (config) => {
  const requestStore = (await storePromise).default;
  const routeId = requestStore.getters['auth/currentRoute'];
  const checkRoute = ongoingRequests.find((ongoingRequest) => ongoingRequest.id === routeId);
  if (config.url !== exceptUrl || !exceptErrorUrls.includes(config.url)) {
    if (checkRoute) {
      const routeIndex = ongoingRequests.findIndex((ongoingRequest) => ongoingRequest.id === routeId);
      ongoingRequests[routeIndex] = {
        id: routeId,
        count: ongoingRequests[routeIndex].count + 1,
      };
    } else {
      ongoingRequests = [{
        id: routeId,
        count: 1,
      }];
    }
  }
  // show loader
  return config;
// eslint-disable-next-line promise/prefer-await-to-callbacks
}, async (error) => {
  const requestStore = (await storePromise).default;
  const routeId = requestStore.getters['auth/currentRoute'];
  const checkRoute = ongoingRequests.find((ongoingRequest) => ongoingRequest.id === routeId);
  if (error.config.url !== exceptUrl || !exceptErrorUrls.includes(error.config.url)) {
    if (checkRoute) {
      const routeIndex = ongoingRequests.findIndex((ongoingRequest) => ongoingRequest.id === routeId);
      ongoingRequests[routeIndex] = {
        id: routeId,
        count: ongoingRequests[routeIndex].count + 1,
      };
    } else {
      ongoingRequests.push({
        id: routeId,
        count: 1,
      });
    }
  }
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(async (response) => {
  const requestStore = (await storePromise).default;
  const routeId = requestStore.getters['auth/currentRoute'];
  const checkRoute = ongoingRequests.find((ongoingRequest) => ongoingRequest.id === routeId);
  const routeIndex = ongoingRequests.findIndex((ongoingRequest) => ongoingRequest.id === routeId);
  if (response.config.url !== exceptUrl || !exceptErrorUrls.includes(response.config.url)) {
    if (checkRoute && +checkRoute.count > 0) {
      ongoingRequests[routeIndex] = {
        id: routeId,
        count: ongoingRequests[routeIndex].count - 1,
      };
    }
  }

  // eslint-disable-next-line no-plusplus,max-len
  if ((response.config.url !== exceptUrl || !exceptErrorUrls.includes(response.config.url)) && +ongoingRequests[routeIndex]?.count === 0) {
    triggerEventBus(routeId);
  }
  return response;
// eslint-disable-next-line promise/prefer-await-to-callbacks
}, async (error) => {
  // eslint-disable-next-line no-plusplus
  const requestStore = (await storePromise).default;
  const routeId = requestStore.getters['auth/currentRoute'];
  const checkRoute = ongoingRequests.find((ongoingRequest) => ongoingRequest.id === routeId);
  const routeIndex = ongoingRequests.findIndex((ongoingRequest) => ongoingRequest.id === routeId);
  if (error.config.url !== exceptUrl || !exceptErrorUrls.includes(error.config.url)) {
    if (checkRoute && +checkRoute.count > 0) {
      ongoingRequests[routeIndex] = {
        id: routeId,
        count: ongoingRequests[routeIndex].count - 1,
      };
    }
  }
  // eslint-disable-next-line max-len
  // if ((error.config.url !== exceptUrl || error.config.url !== errorReportUrl) && +ongoingRequests[routeIndex].count === 0) {
  //   triggerEventBus(routeId);
  // }
  return Promise.reject(error);
});

const ApiService = {
  init() {
    // eslint-disable-next-line no-console
    let store;
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    axios.defaults.xsrfCookieName = 'XTRN-TOKEN';
    axios.defaults.withCredentials = true;
    axios.interceptors.response.use(
      (response) => response,
      // eslint-disable-next-line promise/prefer-await-to-callbacks
      async (error) => {
        if (store == null) {
          store = (await storePromise).default;
        }
        const code = error.request && error.request.status ? error.request.status : null;
        const routeId = store.getters['auth/currentRoute'] || 'default';
        if (error.config.url && !exceptErrorUrls.includes(error.config.url)) {
          const formData = {
            url: error.config.url,
            statusCode: code,
            message: error.message,
            rawResponse: error.response && error.response.data ? JSON.stringify(error.response.data.message) : '',
            rawRequest: error.config && error.config.data ? JSON.stringify(error.config.data) : '',
            pageId: store.getters['auth/currentRoute'],
            type: 1,
          };
          const checkRoute = ongoingRequests.find((ongoingRequest) => ongoingRequest.id === routeId);
          if (checkRoute) {
            const routeIndex = ongoingRequests.findIndex((ongoingRequest) => ongoingRequest.id === routeId);
            ongoingRequests.splice(routeIndex, 1);
          }
          if (code && code !== 503 && code !== 401) {
            const loggedIn = store.getters['user/loggedIn'];
            await store.dispatch('errorReport/store', { form: formData, loggedIn });
          }
        }
        store.commit('appLoading', false);
        let retryCount = 0;
        const maxRetries = 3;
        switch (code) {
          case 401:
            // Unauthorized

            // store.commit('user/sessionExpired');
            // eslint-disable-next-line no-console
            console.log('Redirect to logout');
            await store.dispatch('auth/logout', { forced: true });
            return null;

          case 419:
            // CSRF-token mismatch
            // refresh CSRF token
            // eslint-disable-next-line no-console
            console.log('419-Error');
            if (retryCount < maxRetries) {
              // Refresh CSRF token
              await store.dispatch('auth/cookie');
              // eslint-disable-next-line no-console
              console.log(`retryCount : ${retryCount}`);
              // Retry original request
              retryCount += 1;
              return this.request(error.config);
            }
            // eslint-disable-next-line no-console
            console.log('BeforeInvalidateSession');
            // If maximum retries exceeded, throw an error or handle it as needed
            store.commit('user/sessionExpired');
            await store.dispatch('auth/logout');

            return null;

          case 503:
            // Maintenance mode
            store.commit('system/enableMaintenanceMode');
            return null;

          default:
            throw error;
        }
      },
    );
  },
  setLang(lang) {
    axios.defaults.headers.common['Accept-Language'] = lang;
  },
  setProperty(property) {
    sessionStorage.setItem('activeTab', property);
    const activeTab = sessionStorage.getItem('activeTab');
    if (property != null) {
      axios.defaults.headers.common['X-Property-Id'] = property;
      axios.defaults.headers.common['X-Tab-Property-Id'] = activeTab;
    } else {
      delete axios.defaults.headers.common['X-Property-Id'];
      delete axios.defaults.headers.common['X-Tab-Property-Id'];
    }
  },
  setPageId(pageId) {
    if (pageId != null) {
      axios.defaults.headers.common['X-Page-Id'] = pageId;
    } else {
      delete axios.defaults.headers.common['X-Page-Id'];
    }
  },
  setHeader() {
    // axios.defaults.headers.common.Authorization = `Bearer ${TokenService.getToken()}`;
  },
  removeHeader() {
    // axios.defaults.withCredentials = false;
    // axios.defaults.headers.common = {};
  },
  get(path, config = undefined) {
    return axios.get(path, config);
  },
  post(path, data, config = undefined) {
    return axios.post(path, data, config);
  },
  put(path, data, config = undefined) {
    return axios.put(path, data, config);
  },
  patch(path, data, config = undefined) {
    return axios.patch(path, data, config);
  },
  delete(path, config = undefined) {
    return axios.delete(path, config);
  },
  request(config) {
    return axios(config);
  },
  enableAuthErrorInterceptor() {
  },
  disableAuthErrorInterceptor() {
  },
};

export default ApiService;
